const navigation = {
  id: 'group-dashboard-loading-unique',
  title: 'Navigation',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'collapse',
      icon: 'ph ph-house-line',
      url: '/dashboard',
      children: [
        {
          id: 'dashboard-users',
          title: 'Users',
          type: 'item',
          icon: 'ph ph-users',
          url: '/dashboard'
        },
        {
          id: 'dashboard-workspaces',
          title: 'Workspaces',
          type: 'item',
          icon: 'ph ph-briefcase',
          url: '/dashboard/workspaces'
        }
      ]
    }
  ]
};

export default navigation;
